import { library } from "@fortawesome/fontawesome-svg-core";
import { dom } from "@fortawesome/fontawesome-svg-core";

import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons/faExternalLinkAlt";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons/faLongArrowAltRight";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons/faMapMarkerAlt";
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faPhone } from "@fortawesome/free-solid-svg-icons/faPhone";
import { faCircle } from "@fortawesome/free-solid-svg-icons/faCircle";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { faThermometerHalf } from "@fortawesome/free-solid-svg-icons/faThermometerHalf";
import { faDollarSign } from "@fortawesome/free-solid-svg-icons/faDollarSign";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";

import { faEuroSign } from "@fortawesome/free-solid-svg-icons/faEuroSign";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons/faLongArrowAltDown";
import { faLongArrowAltLeft } from "@fortawesome/free-solid-svg-icons/faLongArrowAltLeft";
import { faLongArrowAltUp } from "@fortawesome/free-solid-svg-icons/faLongArrowAltUp";
import { faComments } from "@fortawesome/free-solid-svg-icons/faComments";
import { faShoppingBasket } from "@fortawesome/free-solid-svg-icons/faShoppingBasket";
import { faSignInAlt } from "@fortawesome/free-solid-svg-icons/faSignInAlt";
import { faBalanceScale } from "@fortawesome/free-solid-svg-icons/faBalanceScale";
import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faThList } from "@fortawesome/free-solid-svg-icons/faThList";
import { faFilter } from "@fortawesome/free-solid-svg-icons/faFilter";
import { faTh } from "@fortawesome/free-solid-svg-icons/faTh";
import { faBan } from "@fortawesome/free-solid-svg-icons/faBan";
import { faHeart } from "@fortawesome/free-solid-svg-icons/faHeart";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { faCalculator } from "@fortawesome/free-solid-svg-icons/faCalculator";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons/faUserPlus";
import { faTruck } from "@fortawesome/free-solid-svg-icons/faTruck";
import { faCar } from "@fortawesome/free-solid-svg-icons/faCar";
import { faTerminal } from "@fortawesome/free-solid-svg-icons/faTerminal";
import { faUniversity } from "@fortawesome/free-solid-svg-icons/faUniversity";
import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo";
import { faRssSquare } from "@fortawesome/free-solid-svg-icons/faRssSquare";

import { faEnvelope } from "@fortawesome/free-regular-svg-icons/faEnvelope";
import { faFileAlt } from "@fortawesome/free-regular-svg-icons/faFileAlt";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons/faFilePdf";
import { faEye } from "@fortawesome/free-regular-svg-icons/faEye";
import { faClock } from "@fortawesome/free-regular-svg-icons/faClock";
import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons/faHeart";
import { faBell } from "@fortawesome/free-regular-svg-icons/faBell";
import { faTimesCircle as farTimesCircle } from "@fortawesome/free-regular-svg-icons/faTimesCircle";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons/faStar";
import { faCreditCard } from "@fortawesome/free-regular-svg-icons/faCreditCard";
import { faMoneyBillAlt } from "@fortawesome/free-regular-svg-icons/faMoneyBillAlt";

import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faVk } from "@fortawesome/free-brands-svg-icons/faVk";
import { faOdnoklassniki } from "@fortawesome/free-brands-svg-icons/faOdnoklassniki";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
dom.watch();

library.add(
  faRssSquare,
  faUndo,
  faTerminal,
  faUniversity,
  faMoneyBillAlt,
  faTruck,
  faUserPlus,
  faCalculator,
  farHeart,
  farTimesCircle,
  faTimesCircle,
  faBan,
  faFilter,
  faThList,
  faTh,
  faBell,
  faCheck,
  farStar,

  faExternalLinkAlt,
  faSearch,
  faChevronUp,
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faMapMarkerAlt,
  faBars,
  faTimes,
  faPhone,
  faCircle,
  faFileAlt,
  faExclamationCircle,
  faThermometerHalf,
  faDollarSign,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faEnvelope,
  faEuroSign,
  faEye,
  faClock,
  faFacebookF,
  faTwitter,
  faVk,
  faOdnoklassniki,
  faInstagram,
  faComments,
  faHeart,
  faShoppingBasket,
  faSignInAlt,
  faStar,
  faBalanceScale,
  faCreditCard,
  faCar,
  faFilePdf,
  faTrash
);
